export const DIV1 = 'Дивизион 1';
export const DIV2 = 'Дивизион 2';
export const DIV3 = 'Дивизион 3';

export const DIVISIONS = {
    [DIV1]: 'bg-info text-center rounded',
    [DIV2]: 'bg-secondary text-center rounded',
    [DIV3]: 'bg-primary  text-center rounded',
}